import { State } from '@ngxs/store';
import { DirectoryOrganisationDataState } from './directory-organisation-data/directory-organisation-data.state';
import { DirectoryStructureState } from './directory-structure/directory-structure.state';
import { Injectable } from '@angular/core';

// tslint:disable-next-line:no-empty-interface
export interface DirectoryStateModel {}

@State<DirectoryStateModel>({
   name: 'directory',
   defaults: {},
   children: [DirectoryStructureState, DirectoryOrganisationDataState],
})
@Injectable()
export class DirectoryState {}
